<template>
  <div class="rt-kind">
    <div class="title">{{ title }}</div>
    <div ref="content" :class="{ more: showMore }" class="content">
      <template v-if="!multiple">
        <template v-if="confirmTitle">
          <rt-popconfirm
            v-for="(item, index) in list"
            :key="index"
            :title="confirmTitle"
            @onConfirm="itemClick(item, index)"
          >
            <div
              slot="reference"
              :class="{ active: currentItem == index }"
              class="__item"
            >
              {{ item[alias.name] }}
            </div>
          </rt-popconfirm>
        </template>
        <template v-else-if="!confirmTitle">
          <div
            v-for="(item, index) in list"
            :key="index"
            :class="{ active: currentItem == index }"
            class="__item"
            @click="itemClick(item, index)"
          >
            {{ item[alias.name] }}
          </div>
        </template>
      </template>
      <template v-else>
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: isCheck(item) }"
          class="__item"
          @click="itemMultipleClick(item)"
        >
          {{ item[alias.name] }}
        </div>
      </template>
    </div>
    <div v-if="showBtn" class="operation">
      <rt-button :suffix-icon="suffixIcon" text @click="showMoreClick">
        更多
      </rt-button>
    </div>
  </div>
</template>

<script>
import RtPopconfirm from '../popconfirm/rtPopconfirm';
const alias = { id: 'id', name: 'name' };
import { store } from '../table/store';
export default {
  name: 'RtKind',
  components: {
    RtPopconfirm
  },
  props: {
    confirmTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    alias: {
      type: Object,
      default() {
        return alias;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      fefault: () => {}
    }
  },
  data() {
    return {
      showMore: false,
      showBtn: false,
      active: false,
      initContentWidth: 0,
      currentItem: -1,
      multipleCheckList: [],
      state: store.state
    };
  },
  computed: {
    suffixIcon() {
      return this.showMore ? 'rt-base-arrow_up' : 'rt-base-arrow_down';
    }
  },
  watch: {
    value(value) {
      if (this.list && this.list.length > 0) {
        this.list.forEach((item, index) => {
          if (value == item) {
            this.currentItem = index;
          }
        });
      }
    },
    list(newValue) {
      this.$nextTick(() => {
        this.contentWidth();
      });
    },
    initContentWidth(newValue) {
      this.$nextTick(() => {
        this.contentWidth();
      });
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      return (() => {
        this.debounce(this.initContentWidthMethod, 800)();
      })();
    });
  },
  methods: {
    itemClick(item, index) {
      if (this.currentItem !== index) {
        this.currentItem = index;
        this.$emit('confirm', item);
      } else {
        this.currentItem = -1;
        this.$emit('confirm');
      }
    },
    itemMultipleClick(row) {
      let index = -1;
      for (let i = 0; i < this.multipleCheckList.length; i++) {
        if (this.multipleCheckList[i][this.alias.id] === row[this.alias.id]) {
          index = i;
          break;
        }
      }
      if (index >= 0) {
        this.multipleCheckList.splice(index, 1);
      } else {
        this.multipleCheckList.push(row);
      }
      this.$emit('confirm', this.multipleCheckList);
    },
    isCheck(row) {
      var isChecked = false;
      if (this.multipleCheckList) {
        this.multipleCheckList.map(item => {
          if (item[this.alias.id] === row[this.alias.id]) {
            isChecked = true;
            return;
          }
        });
      }
      return isChecked;
    },
    initContentWidthMethod() {
      this.initContentWidth = window.innerWidth;
    },
    showMoreClick() {
      this.showMore = !this.showMore;
    },
    contentWidth() {
      let content = this.$refs.content;
      let contentWidth = this.$refs.content.offsetWidth;
      let listWidth = 0;
      let itemNodeList = content.querySelectorAll('.item');
      let arr_item = Array.prototype.slice.call(itemNodeList);
      if (arr_item.length > 0) {
        arr_item.map(item => {
          listWidth += item.offsetWidth + 32;
        });
      }
      this.showBtn = listWidth > contentWidth - 48 ? true : false;
    },
    debounce(fn, delay) {
      let timer = null;
      return function() {
        let context = this;
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function() {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtKind.vue?2c8541f0